import api from "../datasource/api";

export const getOccupancyData = async (
    cumulativestartdate: any,
    cumulativeenddate: any,
    start: any,
    end: any,
    hospitallocationtypeid: any,
    hospitalid: any,
    isSingle: any
) => {

    if (isSingle) {
        const response = await api.get("/CMMIS/ccmis/GetFacilityLocationOccupancyDetails", {
            params: {
                cumulativestartdate,
                cumulativeenddate,
                startdate: start,
                enddate: end,
                facilityManageType: 1,
                hospitallocationtypeid,
                hospitalid
            }
        });

        const data = response.data;

        const vacantBeds = (data.vacantBeds - (data.occupiedBeds + data.bookedBeds) < 0) ? 0 : data.vacantBeds - (data.occupiedBeds + data.bookedBeds);

        const totalBeds =
            (vacantBeds || 0) +
            (data.occupiedBeds || 0) +
            (data.bookedBeds || 0);

        const getPercentage = (value: number) =>
            totalBeds ? Math.round((value / totalBeds) * 100) : 0;

        return {
            names: ["Vacant Beds", "Occupied Beds", "Booked Beds"],

            counts: [
                vacantBeds || 0,
                data.occupiedBeds || 0,
                data.bookedBeds || 0
            ],

            percentages: [
                getPercentage(vacantBeds || 0),
                getPercentage(data.occupiedBeds || 0),
                getPercentage(data.bookedBeds || 0)
            ],

            colors: ['#1FAC86', '#F3A11E', '#764FA0'],

            subTitles: [
                {
                    title: "Occupied Bed Days",
                    count: data.occupiedBedDays || 0,
                    percentage: data.totalBedDays
                        ? Math.round((data.occupiedBedDays / data.totalBedDays) * 100)
                        : 0,
                },
                {
                    title: "No. of Patients",
                    count: data.totalPatients || 0,
                },
                {
                    title: "Avg Patient Stay",
                    count: data.averagePatientStay || 0,
                }
            ],

            total: totalBeds
        };
    } else {

        const response = await api.get("/CMMIS/ccmis/GetFacilityLocationOccupancyHours", {
            params: {
                cumulativestartdate,
                cumulativeenddate,
                startdate: start,
                enddate: end,
                facilityManageType: 2,
                hospitallocationtypeid,
                hospitalid
            }
        });

        const data = response.data;

        // Decide values
        const booked = data.bookedHours || 0;
        const available = data.availableFacilityhours || 0; // better than vacantHours (0 in your case)

        const total = booked + available + data?.unusedHours;

        const getPercentage = (value: number) =>
            total ? Math.round((value / total) * 100) : 0;

        return {
            names: ["Booked Hours", "Available Hours", 'Unused Hours'],
            noOfFacilities: data?.noOfFacilities,
            noOfCares: data?.noOfCares,
            counts: [
                booked,
                available,
                data?.unusedHours
            ],

            // optional if your chart needs it
            percentages: [
                getPercentage(booked),
                getPercentage(available),
                getPercentage(data?.unusedHours),
            ],

            colors: ['#F3A11E', '#764FA0', '#E27C8B'],

            subTitles: [
                {
                    title: "Total Surgeries",
                    count: data.noOfCares || 0, // or noOfCaresCumulative if needed
                    percentage: null
                },
                {
                    title: "Surgery Hours",
                    count: data.noOfCareHours || 0,
                },
                {
                    title: "No. of Patients",
                    count: data.noOfPatientCumulative || 0,
                }
            ],

            total
        };
    }



    // switch (bedType) {
    //     case "ICU":
    //         return {
    //             names: ["Vacant Beds", "Occupied Beds", "Booked Beds"],
    //             counts: [15, 10, 10],
    //             percentages: [60, 40, 40],
    //             colors: ['#1FAC86', '#F3A11E', '#764FA0'],
    //             subTitles: [
    //                 {
    //                     title: "Occupied Bed Days",
    //                     count: 3650,
    //                     percentage: 45,
    //                 },
    //                 {
    //                     title: "No. of Patients",
    //                     count: 1000,
    //                 },
    //             ],
    //             total: 35,

    //         };
    //     case "Ward":
    //         return {
    //             names: ["Vacant Beds", "Occupied Beds", "Booked Beds"],
    //             counts: [15, 10, 10],
    //             percentages: [60, 40, 40],
    //             colors: ['#F5B44B', '#1FAC86', '#DC6375'],
    //             subTitles: [
    //                 {
    //                     title: "Occupied Bed Days",
    //                     count: 3650,
    //                     percentage: 45,
    //                 },
    //                 {
    //                     title: "No. of Patients",
    //                     count: 1000,
    //                 },
    //             ],
    //             total: 35,

    //         };
    //     case "OT":
    //         return {
    //             names: ["Booked Hours", "Available Hours"],
    //             counts: [10, 14],
    //             colors: ['#F3A11E', '#764FA0'],
    //             subTitles: [
    //                 {
    //                     title: "Total Surgeries",
    //                     count: 20,
    //                     percentage: null
    //                 },
    //                 {
    //                     title: "Surgery Hours",
    //                     count: 4,
    //                 },
    //             ],
    //             total: 24,

    //         };
    //     default:
    //         break;
    // }

};
